import apiUtils from "../utils/api-utils";

export default {
	GetPropertyDocumentInfo: async function (token: string) {
		try {
			const result = await apiUtils.axiosInstance.get(
				`/external-supplier/get-property-document-info?token=${token}`
			);
			return result.data;
		} catch (error) {
			console.log("[GetPropertyDocumentInfo] ERROR", error);
		}
	},

	UploadPropertyDocuments: async function (token: string, payload: any) {
		const response = await apiUtils.axiosInstance.post(
			`external-supplier/upload-property-document?token=${token}`,
			{ ...payload }
		);
		return response;
	}
};
